var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../node_modules/css-loader/index.js?minimize!../../node_modules/vue-swipe/dist/vue-swipe.css"), "");

// module
exports.push([module.id, ".intro-swipe{height:500px;font-size:10px}.intro_iphone_remote_control{background:url(" + escape(require("../assets/images/intro_iphone_remote_control.jpeg")) + ") no-repeat 50%;background-size:contain}.intro_iphone_trackpad_ipad_remote_control{background:url(" + escape(require("../assets/images/intro_iphone_trackpad_ipad_remote_control.jpeg")) + ") no-repeat 50%;background-size:contain}.intro_iphone_keyboard{background:url(" + escape(require("../assets/images/intro_iphone_keyboard.jpeg")) + ") no-repeat 50%;background-size:contain}.intro_apple_watch_trackpad{background:url(" + escape(require("../assets/images/intro_apple_watch_trackpad.jpeg")) + ") no-repeat 50%;background-size:contain}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1bd1d10f","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/IntroSwipe.vue
// module id = 60
// module chunks = 0